import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

export const URL_SHIFTS = `${URL_RETAILER_SCOPED}/shifts`
export const URL_CSV_HISTORY = `${URL_SHIFTS}/csv-history`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'shifts' | 'csvHistory'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  shifts: URL_SHIFTS,
  csvHistory: URL_CSV_HISTORY,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
